import { Button, Heading, HFlow, Icon, VFlow } from 'bold-ui'
import { TipoRegulacaoEnum } from 'graphql/types.generated'
import React from 'react'
import { useHistory } from 'react-router'

import { ListaRegulacaoTableItem } from '../../model-regulacao'
import { RegulacaoModalItemGuiaEncaminhamento } from './RegulacaoModalItemGuiaEncaminhamento'
import { RegulacaoModalItemSolicitacaoExame } from './RegulacaoModalItemSolicitacaoExame'

type RegulacaoModalItemProps = {
  item: ListaRegulacaoTableItem
}

export const RegulacaoModalItem = (props: RegulacaoModalItemProps) => {
  const { item } = props

  const history = useHistory()

  const handleClick = () => {
    history.push(`/cidadao/${item.prontuario.cidadao.id}/folha-rosto`)
  }

  return (
    <VFlow vSpacing={0.5}>
      <HFlow justifyContent='space-between' alignItems='center'>
        <Heading level={2}>Sobre a solicitação</Heading>
        <Button skin='outline' kind='primary' size='small' onClick={handleClick}>
          <HFlow hSpacing={0.5} alignItems='center'>
            <Icon icon='userOutline' fill='primary' />
            <Heading level={4} color='primary'>
              Visualizar prontuário
            </Heading>
          </HFlow>
        </Button>
      </HFlow>
      {item.tipoRegulacao === TipoRegulacaoEnum.GUIA_ENCAMINHAMENTO ? (
        <RegulacaoModalItemGuiaEncaminhamento item={item} />
      ) : (
        <RegulacaoModalItemSolicitacaoExame item={item} />
      )}
    </VFlow>
  )
}
